import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";
import Switch from "react-switch";
import { toast } from 'react-toastify';

import CustomModal from "../../../components/Modal/CustomModal";
import ItemsTable from "./ItemsTable";

import { ConsultaTasas, AddItem, EditItem, DelItem } from "../../../funciones/IngresosFunction";

let idItem = "";
let idItemDel = "";
class Tasas extends Component {
    state = {
        item: "",
        uc: "",
        activo: true,
        items:[],
        preloader: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Cargando Lista</React.Fragment>,
        valorUc: 0,
        valorUcNi: 0,
        boton1:{
            icono: "fa fa-save",
            texto: "Guardar"
        },
        openWAdd: false,
        openWEdit: false,
        openWDel: false,
        btnAdd: {
            icon: "fa fa-check",
            text: "Si"
        },
        btnEdit: "fa fa-save",
        btnCancel: "fa fa-times",
        disabledI: false
    }

    componentDidMount = () => {
        idItem = "";
        ConsultaTasas((resp) => {
            this.setState({
                items: resp[0],
                valorUc: parseFloat(resp[1]),
                valorUcNi: parseFloat(resp[2])
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase() 
        });
    };

    cambiaValorNum = (prop) => (event) => {
        if (!isNaN(Number(event.target.value)) === false) return null;
        this.setState({
            [prop]: event.target.value 
        });
    };

    cancelar = () => {
        idItem = "";
        this.setState({
            item: "",
            uc: "",
            activo: true,
            disabledI: false
        });
    }

    editItemTable = (id, item, uc, status) => {
        let activo = true;
        if (status === "0") activo = false;
        idItem = id
        this.setState({
            item: item,
            uc: uc,
            activo: activo,
            disabledI: true
        })
    }

    delIt = (id) => {
        idItemDel = id;
        if (idItemDel === ""){
            toast.info("No has elegido ningún ítem",{autoClose: 4000});
            return null;
        }
        this.setState({
            openWDel: true
        })
    }

    modalDel = () => {
        const { openWDel, btnAdd } = this.state;
        if (idItemDel === "") return null;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas eliminar este <strong>Item</strong> de la <strong className="text-danger">Lista de Ingresos por Tasas</strong>?</div>
                <div className="text-muted" style={{fontSize: 10}}>Esta opción no puede deshacerse</div>
            </React.Fragment>
        )

        let BorrarItem = () => {
            this.setState({
                btnAdd: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                DelItem (idItemDel, (resp) => {
                    toast.info("Has eliminado correctamente el ítem",{autoClose: 4000});
                    ConsultaTasas((resp) => {
                        this.setState({
                            items: resp[0],
                            valorUc: parseFloat(resp[1]),
                            valorUcNi: parseFloat(resp[2]),
                            openWDel: false,
                            btnAdd: {
                                icon: "fa fa-check",
                                text: "Si"
                            },
                            item: "",
                            uc: "",
                            activo: true,
                        })
                    })
                    this.cancelar()
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={btnAdd.icon}></i> {btnAdd.text}</React.Fragment>}
                large = "medium"
                isopen =  {openWDel}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {BorrarItem}
                funcion2 = {() => {this.setState({openWDel: false})}}
            />
        );
    }

    modalEdit = () => {
        const { openWEdit, btnAdd, item, uc, activo } = this.state;
        if (idItem === "") return null;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas guardar los cambios de este <strong>Item</strong> de la <strong className="text-danger">Lista de Ingresos por Tasas</strong>?</div>
            </React.Fragment>
        )

        let EditarItem = () => {
            this.setState({
                btnAdd: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                EditItem (idItem, item, uc, activo, (resp) => {
                    toast.info("Has modificado correctamente el ítem",{autoClose: 4000});
                    ConsultaTasas((resp) => {
                        this.setState({
                            items: resp[0],
                            valorUc: parseFloat(resp[1]),
                            valorUcNi: parseFloat(resp[2]),
                            openWEdit: false,
                            btnAdd: {
                                icon: "fa fa-check",
                                text: "Si"
                            },
                            item: "",
                            uc: "",
                            activo: true,
                        })
                    })
                    this.cancelar()
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={btnAdd.icon}></i> {btnAdd.text}</React.Fragment>}
                large = "medium"
                isopen =  {openWEdit}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {EditarItem}
                funcion2 = {() => {this.setState({openWEdit: false})}}
            />
        );
    }

    modalAdd = () => {
        const { openWAdd, btnAdd, item, uc, activo } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Deseas agregar este <strong>Item</strong> a la <strong className="text-danger">Lista de Ingresos por Tasas</strong>?</div>
            </React.Fragment>
        )

        let AgregarItem = () => {
            this.setState({
                btnAdd: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera"
                }
            }, () => {
                AddItem (item, uc, activo, (resp) => {
                    toast.info("Has agregado correctamente el ítem",{autoClose: 4000});
                    ConsultaTasas((resp) => {
                        this.setState({
                            items: resp[0],
                            valorUc: parseFloat(resp[1]),
                            valorUcNi: parseFloat(resp[2]),
                            openWAdd: false,
                            btnAdd: {
                                icon: "fa fa-check",
                                text: "Si"
                            },
                            item: "",
                            uc: "",
                            activo: true,
                        })
                    })
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={btnAdd.icon}></i> {btnAdd.text}</React.Fragment>}
                large = "medium"
                isopen =  {openWAdd}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {AgregarItem}
                funcion2 = {() => {this.setState({openWAdd: false})}}
            />
        );
    }

    contenido = () => {
        let { item, uc, activo, items, preloader, valorUc, valorUcNi, boton1, btnEdit, btnCancel, disabledI } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let listaCostos = () => {
            if (items.length === 0) return (
                <tr>
                    <td colSpan={4} align="center">{preloader}</td>
                </tr>
            )

            return (
                items.map(option => (
                    <ItemsTable key={option.id} datos={option} valorUc = {valorUc} valorUcNi = {valorUcNi}
                    edit = {(id, item, uc, status) => {this.editItemTable(id, item, uc, status)}}
                    del ={(id) => {this.delIt(id)}}/>
                ))
            )
        }

        let botones = () => {
            if (idItem === ""){
                return (
                    <button className="btn btn-primary" style={{borderWidth: 1}} onClick={()=> {
                        if (item === "") {
                            toast.error("Debes agregar la descripción del Item",{autoClose: 4000});
                            return null;
                        }
                        if (uc === "") {
                            toast.error("Debes agregar las Unidades de Crédito",{autoClose: 4000});
                            return null;
                        }
                        if (!isNaN(Number(uc)) === false) {
                            toast.error("El campo Unidades de Crédito debe contener solo números",{autoClose: 4000});
                            return null;
                        }
                        this.setState({openWAdd: true})
                    }}><i className={boton1.icono}></i> {boton1.texto}</button>
                )
            }
            
            return (
                <div className="btn-group">
                    <button className="btn btn-warning" onClick={()=> {
                        if (item === "") {
                            toast.error("Debes agregar la descripción del Item",{autoClose: 4000});
                            return null;
                        }
                        if (uc === "") {
                            toast.error("Debes agregar las Unidades de Crédito",{autoClose: 4000});
                            return null;
                        }
                        if (!isNaN(Number(uc)) === false) {
                            toast.error("El campo Unidades de Crédito debe contener solo números",{autoClose: 4000});
                            return null;
                        }
                        this.setState({openWEdit: true})
                    }} style={{borderWidth:1}} title="Guardar los cambios"><i className={btnEdit}></i></button>
                    <button className="btn btn-danger" onClick={this.cancelar} style={{borderWidth:1}} title="Cancelar"><i className={btnCancel}></i></button>
                </div>
            )
            
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info" style={{padding: 5}}>Agrega un Nuevo Item</div>
                <Row className="custom-mt-10">
                    <Col md={4}>
                        <input className="form-control" disabled = {disabledI} value={item} onChange={this.cambiaValor("item")} placeholder="Ingresa el nombre del Item"/>
                        <div className="text-muted" style={{fontSize: 12}}>Nombre</div>
                    </Col>
                    <Col md={2}>
                        <input className="form-control" value={uc} maxLength={2} onChange={this.cambiaValorNum("uc")} placeholder="U.C."/>
                        <div className="text-muted" style={{fontSize: 12}}>Unidades de Crédito</div>
                    </Col>
                    <Col md={3} align="center" style={{paddingTop: 10}}>
                        <Switch height={15} width={30} onChange={()=> {this.setState({activo: !this.state.activo})}} checked={activo} />
                        <div className="text-muted" style={{fontSize: 12}}>Desactivado / Activado</div>
                    </Col>
                    <Col md={3} align="right" style={{paddingTop: 5}}>
                        {botones()}
                    </Col>
                </Row>
                <div className="custom-alert-info custom-mt-10" style={{padding: 5}}>Lista de Ingresos por Tasas</div>

                <div className="table-responsive custom-mt-10" style={{backgroundColor: "#FFF", border: "1px solid #1f2f6e",/*  maxHeight: "40vh", overflowY: "auto" */}}>
                    <Table striped bordered hover style={{marginBottom: 0}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Item</strong></td>
                                <td width="15%" style={styles} align="center"><strong>U.C.</strong></td>
                                <td width="20%" style={styles} align="center">
                                    <strong>Total Bs.</strong>
                                    <div style = {{fontSize: 10}}><strong>REGULARES</strong></div>
                                </td>
                                <td width="20%" style={styles} align="center">
                                    <strong>Total Bs.</strong>
                                    <div style = {{fontSize: 10}}><strong>NUEVO INGRESO</strong></div>
                                </td>
                                <td width="100px" style={styles} align="center"><strong>Acciones</strong></td>
                            </tr>
                            {listaCostos()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En este módulo puedes ver, agregar, modificar y/o eliminar los items que puedes utilizar.
            </Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Agregar Item</strong></Col>
            <Col md={12} align="justify">
                Para añadir un nuevo ítem, primero llena los campos <strong>Nombre</strong> y <strong>Unidades de Crédito</strong> e indica su estado <strong>(Desactivado / Activado)</strong>
            </Col>
            <Col md={12} align="justify">
                Presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i> Guardar</button> para almacenar el nuevo ítem.
            </Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Editar Item</strong></Col>
            <Col md={12} align="justify">
                Selecciona un <strong>Item</strong> de la lista y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Haz click en la opción <span className="text-primary"><i className ="fa fa-edit"></i> Modificar</span> para que los datos del ítem se reflejen en el formulario de arriba
            </Col>

            <Col md={3} className="custom-mt-10"><button className="btn btn-warning btn-xs" style={{borderWidth: 1}}><i className="fa fa-save"></i></button></Col>
            <Col md={9} className="custom-mt-10" align="justify">Este botón te permitirá guardar los cambios</Col>
            <Col md={3}><button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-times"></i></button></Col>
            <Col md={9} align="justify">Este botón cancela la selección</Col>

            <Col md={12} className="text-primary custom-mt-10"><strong>Eliminar Item</strong></Col>
            <Col md={12} align="justify">
                Selecciona un <strong>Item</strong> de la lista y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
            </Col>
            <Col md={12} align="justify" className="custom-mt-10">
                Haz click en la opción <span className="text-danger"><i className ="fa fa-trash"></i> Eliminar</span> y confirma para que el ítem se elmimine definitivamente
            </Col>
        </Row>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Ingresos por Tasas</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalAdd()}
                {this.modalEdit()}
                {this.modalDel()}
            </div>
        );
    }
}
 
export default Tasas;


// WEBPACK FOOTER //
// ./src/views/Administracion/IngresosContent/Tasas.jsx